// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateDeliveryAddressRequestModel from '../../model/update-delivery-address-request-model';
import UpdateDeliveryAddressRequestDTO from '../dto/update-delivery-address-request-dto';
import dtoSchema from '../schemas/update-delivery-address-request-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class UpdateDeliveryAddressRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateDeliveryAddressRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.isDifferent = data.isDifferent;
      this.salutation = data.salutation ?? undefined;
      this.company = data.company ?? undefined;
      this.firstName = data.firstName ?? undefined;
      this.lastName = data.lastName ?? undefined;
      this.street = data.street ?? undefined;
      this.houseNumber = data.houseNumber ?? undefined;
      this.poBox = data.poBox ?? undefined;
      this.additionalLine = data.additionalLine ?? undefined;
      this.postalCode = data.postalCode ?? undefined;
      this.city = data.city ?? undefined;
      this.countryIso2 = data.countryIso2 ?? undefined;
      this.phone = data.phone ?? undefined;
      this.mobilePhone = data.mobilePhone ?? undefined;
      this.email = data.email ?? undefined;
      this.isReadonly = data.isReadonly;
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  isDifferent?: boolean;
  /**
  * @type {int32}
  */
  salutation?: 0 | 1 | null; // ShopSalutationTypeResourceNullableDTO
  /**
  */
  company?: string;
  /**
  */
  firstName?: string;
  /**
  */
  lastName?: string;
  /**
  */
  street?: string;
  /**
  */
  houseNumber?: string;
  /**
  */
  poBox?: string;
  /**
  */
  additionalLine?: string;
  /**
  */
  postalCode?: string;
  /**
  */
  city?: string;
  /**
  */
  countryIso2?: string;
  /**
  */
  phone?: string;
  /**
  */
  mobilePhone?: string;
  /**
  */
  email?: string;
  /**
  */
  isReadonly?: boolean;
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<UpdateDeliveryAddressRequestDTO>): UpdateDeliveryAddressRequestModel;
  static toModel(dto: DeepPartial<UpdateDeliveryAddressRequestDTO> | undefined | null): UpdateDeliveryAddressRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateDeliveryAddressRequestDTO> | undefined | null): UpdateDeliveryAddressRequestModel | undefined {
    return dto ? new UpdateDeliveryAddressRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateDeliveryAddressRequestModel> | UpdateDeliveryAddressRequestModel): UpdateDeliveryAddressRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      isDifferent: unwrapped.isDifferent,
      salutation: unwrapped.salutation,
      company: unwrapped.company,
      firstName: unwrapped.firstName,
      lastName: unwrapped.lastName,
      street: unwrapped.street,
      houseNumber: unwrapped.houseNumber,
      poBox: unwrapped.poBox,
      additionalLine: unwrapped.additionalLine,
      postalCode: unwrapped.postalCode,
      city: unwrapped.city,
      countryIso2: unwrapped.countryIso2,
      phone: unwrapped.phone,
      mobilePhone: unwrapped.mobilePhone,
      email: unwrapped.email,
      isReadonly: unwrapped.isReadonly,
      userId: unwrapped.userId,
    } as UpdateDeliveryAddressRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateDeliveryAddressRequestModel, can not map to UpdateDeliveryAddressRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
